import { render, staticRenderFns } from "./ExtraOption.vue?vue&type=template&id=bf94c534&scoped=true"
import script from "./ExtraOption.vue?vue&type=script&lang=js"
export * from "./ExtraOption.vue?vue&type=script&lang=js"
import style0 from "./ExtraOption.vue?vue&type=style&index=0&id=bf94c534&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf94c534",
  null
  
)

export default component.exports